import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ZoneSelector } from './components/ZoneSelector';
import { FeaturedRestaurants } from './components/FeaturedRestaurants';
import { CategorySection } from './components/CategorySection';
import { TopReviews } from './components/TopReviews';
import { CantonView } from './components/CantonView';
import { RestaurantDetail } from './components/RestaurantDetail';
import { OwnerForm } from './components/OwnerForm';
import { Footer } from './components/Footer';
type ViewState = 'home' | 'canton' | 'restaurant' | 'owner-form';
export function App() {
  const [currentView, setCurrentView] = useState<ViewState>('home');
  const [selectedCanton, setSelectedCanton] = useState<string | null>(null);
  const [selectedRestaurant, setSelectedRestaurant] = useState<string | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentView, selectedCanton, selectedRestaurant]);
  const handleNavigate = (view: ViewState) => {
    setCurrentView(view);
    if (view === 'home') {
      setSelectedCanton(null);
      setSelectedRestaurant(null);
    }
  };
  const handleSelectCanton = (id: string) => {
    setSelectedCanton(id);
    setCurrentView('canton');
  };
  const handleSelectRestaurant = (id: string) => {
    setSelectedRestaurant(id);
    setCurrentView('restaurant');
  };
  const handleShowOwnerForm = () => {
    setCurrentView('owner-form');
  };
  const handleBack = () => {
    if (currentView === 'restaurant') {
      if (selectedCanton) {
        setCurrentView('canton');
      } else {
        setCurrentView('home');
      }
      setSelectedRestaurant(null);
    } else if (currentView === 'canton') {
      setCurrentView('home');
      setSelectedCanton(null);
    } else if (currentView === 'owner-form') {
      setCurrentView('home');
    }
  };
  return <div className="min-h-screen bg-bg-primary text-text-primary font-body selection:bg-brand-gold/20 selection:text-white" data-id="element-0">
      <Navbar currentView={currentView} onNavigate={handleNavigate} onBack={handleBack} onSelectRestaurant={handleSelectRestaurant} onShowOwnerForm={handleShowOwnerForm} data-id="element-1" />

      <main className="relative z-10 min-h-[calc(100vh-80px)]" data-id="element-2">
        {currentView === 'home' && <>
            <HeroSection onSelectCanton={handleSelectCanton} onSelectRestaurant={handleSelectRestaurant} data-id="element-3" />
            <ZoneSelector onSelectCanton={handleSelectCanton} data-id="element-4" />
            <FeaturedRestaurants onSelectRestaurant={handleSelectRestaurant} data-id="element-5" />
            <CategorySection data-id="element-6" />
            <TopReviews onSelectRestaurant={handleSelectRestaurant} data-id="element-7" />
          </>}

        {currentView === 'canton' && selectedCanton && <CantonView cantonId={selectedCanton} onSelectRestaurant={handleSelectRestaurant} onBack={handleBack} data-id="element-8" />}

        {currentView === 'restaurant' && selectedRestaurant && <RestaurantDetail restaurantId={selectedRestaurant} onBack={handleBack} data-id="element-9" />}

        {currentView === 'owner-form' && <OwnerForm onBack={handleBack} data-id="element-10" />}
      </main>

      <Footer data-id="element-11" />
    </div>;
}